import React, { useState, useEffect } from 'react';
import Select from "react-select";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Image
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { ThreeDots } from 'react-loader-spinner';
import Swal from "sweetalert2";
import { getLeaveBalances, resetForm, updateBalance } from "../../3.Store/ApplicationSlice";
import { 
  resetClaim,
  updateMedicalClaim,
  updateAttachment,
  addMedicalClaim,
  addMedicalClaimAttachment
} from '../../3.Store/MedicalClaimSlice';
import { approveReviewMedicalClaims } from "../../3.Store/ReviewMedicalClaimsSlice";
import { openEditor } from "react-profile";
import "react-profile/themes/default";
import { postsearchText } from "../../3.Store/EmployeeSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PDFViewer from "../../2.Commons/PDFViewer";

const HRMedicalClaimApplicationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fullImage, setFullImage] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [employeeid, setemployeeid] = useState(null); 
  const employees = useSelector(state => state.EmployeeSlice.employees);
  const medical_claim = useSelector(state => state.MedicalClaimSlice.medicalClaim);
  const attachment = useSelector(state => state.MedicalClaimSlice.attachment);
  const { balance } = useSelector((state) => state.ApplicationSlice);
  const { amount, receipt_reference, receipt_no, claim_date } = medical_claim || {};

  console.log(balance);

  const role = JSON.parse(localStorage.getItem("roles"));

  useEffect(() => {
    if (!role || !role.includes("HR-M-APPLY")) {  // Check required role 
      localStorage.clear(); 
      window.location.href = "/Login";
    }

    if(selectedOption === null)
    {
      setemployeeid(null);
    }
  }, []);

  useEffect(() => {
    if (employeeid) {
      const fetchData = async () => {
        setLoading(true);
        const entity = {
          ...medical_claim,
          claim_date: moment(new Date()).format("YYYY-MM-DD"),
        };

        try {
          await dispatch(getLeaveBalances({ id: employeeid }));
          await dispatch(updateMedicalClaim(entity));
        } catch (error) {
          console.error("Error fetching leave balances or updating claim:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
    else {
      dispatch(resetForm());
      dispatch(resetClaim());
    }
  }, [employeeid]); 

  useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      const entity = { searchText: inputValue, active: 1}
      dispatch(postsearchText(entity));
    }
  }, [inputValue]);

  const options = employees.map(employee => ({
    label: employee.fullname,
    value: employee.fullname,
    id: employee.id
  }));

  const handleDropdownEmployee = (selectedOption) => {
    // Find the selected option based on ID
    const selectedEmployee = options.find(option => option.id === selectedOption.id);
    
    setSelectedOption(selectedEmployee);
    console.log("Selected Employee ID:", selectedEmployee?.id);
    
    setemployeeid(selectedEmployee?.id); // This update is asynchronous
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });

      event.target.value = null;

      const entity = {
        ...attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateAttachment(entity));
      return;
    }

    setLoading(true);

    try {
      const fileResult = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(selectedFile);
      });

      let base64String;

      if (selectedFile.type === 'application/pdf') {
        base64String = fileResult.split(',')[1];
      } else {
        setFullImage(fileResult);
        setLoading(false);
        const editor = await openEditor({ src: selectedFile });

        if (!editor?.editedImage) {
          throw new Error("Failed to get edited image.");
        }

        base64String = editor.editedImage.getDataURL();
      }

      const entity = {
        ...attachment,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };

      dispatch(updateAttachment(entity));

      console.log("Base64 File:", base64String);
      console.log("Filename:", selectedFile.name);
      console.log("Filetype:", selectedFile.type);
      console.log("Filesize:", selectedFile.size, "bytes");

      // Simulate a short delay like original `setTimeout`
      await new Promise((res) => setTimeout(res, 1000));

    } catch (error) {
      console.error("Attachment error:", error);

      Swal.fire({
        text: error.message.includes("edited image")
          ? "There was an error editing the image."
          : "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });

      const entity = {
        ...attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateAttachment(entity));
    } finally {
      setLoading(false);
    }
  }; 

  const handleFormChange = (e) => {
    const entity = { ...medical_claim, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateMedicalClaim(entity));
  };

  const handleBtnBack = () => {
    dispatch(resetClaim());
    navigate("/");
  };

  const handleBtnAdd = async () => {
    if (!employeeid) {
      Swal.fire({
        title: "Please select an employee",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;

    }
    if (amount <= 0) {
      Swal.fire({
        title: "Please enter the correct amount",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    if (!receipt_no || !receipt_reference) {
      Swal.fire({
        title: "Please fill in both Practitioner and Receipt No",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }        

    if (!attachment || Object.keys(attachment).length === 0) {
      Swal.fire({
        text: "Please attach your receipt. / Sila lampirkan resit anda.",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return; // Stop submission
    }

    // if (parseFloat(amount) > parseFloat(balance?.medical_benefit || 0)) {
    //   Swal.fire({
    //     text: "Claim amount exceeds available balance. / Jumlah tuntutan melebihi baki yang ada.",
    //     icon: "warning",
    //     confirmButtonText: "OK"
    //   });
    //   return;
    // }

    setLoading(true);
    try {
      const addedClaim = await dispatch(addMedicalClaim({ ...medical_claim, id: employeeid })).unwrap();
      const claimId = addedClaim.id;
      console.log(claimId)
      const entity = { ...attachment, id: {id: claimId}};
      await dispatch(addMedicalClaimAttachment({ ...entity })).unwrap();
      // await dispatch(approveReviewMedicalClaims([claimId]));
      setLoading(false);
      await Swal.fire("Medical Claim Added", "", "success");
      navigate("/HRReviewMedicalList");
    } catch (err) {
      setLoading(false);
      Swal.fire("Error", err.response?.data || "An error occurred", "error");
    }
  };

  const handleEditImage = async () => {
    if (fullImage) {
      try {
        const editor = await openEditor({ src: fullImage });

        if (editor && editor.editedImage) {
          const updatedImage = editor.editedImage.getDataURL();
          const entity = { ...attachment, file: updatedImage };
          dispatch(updateAttachment(entity));
        } else {
          console.error("Edited image not found.");
        }
      } catch (error) {
        console.error("Error opening editor:", error);
      }
    } else {
      console.error("Full image is not set.");
    }
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup className="my-2">
            {/* {!id && (
              <Button className="Button" onClick={handleBtnAdd}>
                Submit
              </Button>
            )} */}
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">HR Medical Claim Application</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Employee Name</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Select
              inputValue={inputValue}
              onInputChange={(value) => setInputValue(value)}
              name="name"
              onChange={handleDropdownEmployee}
              options={options}
              value={selectedOption}
              placeholder="Select Employee"
            />
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Invoice Date</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <DatePicker
              selected={claim_date ? new Date(claim_date) : null}
              onChange={(date) =>
                handleFormChange({
                target: {
                    name: "claim_date",
                    value: moment(date).format("YYYY-MM-DD"),
                },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
            {/* <Form.Control type="date" name="claim_date" value={moment(claim_date).format("YYYY-MM-DD")} onChange={handleFormChange}/> */}
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Practitioner</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="receipt_no" value={receipt_no} onChange={handleFormChange} placeholder="Enter Practitioner"/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">
              Claim (RM) Balance RM{balance?.medical_benefit || 0}
            </Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="amount" value={amount} onChange={handleFormChange}/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Receipt No</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="receipt_reference" value={receipt_reference} onChange={handleFormChange} placeholder="Enter Receipt No"/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Form.Control type="file" onChange={handleFileChange} />
          </Col>
        </Row>

        {/* Conditional rendering based on attachment existence */}
        {attachment && attachment.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {attachment.filetype.startsWith('image/') && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor: '#373c40',
                    height: '500px',
                    width: "100%",
                    overflow: 'auto',
                  }}
                >
                  <Image
                    src={attachment.file}
                    alt="Uploaded file"
                    fluid
                    style={{
                      maxWidth: '100%',
                      height: '100%',
                    }}
                    onClick={handleEditImage} // Optional: Click handler
                  />
                </div>
              )}

              {/* Display PDF */}
              {!attachment.filetype.startsWith('image/') && (
                // <iframe
                //   src={`data:${attachment.filetype};base64,${attachment.file}`}
                //   title="PDF file"
                //   width="100%"
                //   height="500px"
                // ></iframe>
                attachment.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={attachment.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${attachment.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
              )}
            </Col>
          </Row>
        )}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup className="my-2">
            {!id && (
              <Button className="Button" onClick={handleBtnAdd}>
                Submit
              </Button>
            )}
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default HRMedicalClaimApplicationForm;